import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter } from '../WithRouterHOC';
import { Button, Checkbox, message, Modal, Popover } from 'antd';
import { HistoryOutlined, QuestionCircleOutlined } from '@ant-design/icons';
import qs from 'qs';
import IframeModal from '../iframModal/IframModal';
import HTTP from '../../script/service';
import Util from '../../script/util';
import { _h5_link_to, _show_god_end_visible } from '../../store/Action';
import ChangePhone from '../center/changePhone/ChangePhone';
import BindBank from '../center/bindBank/BindBank';
import ApplyRef from './apply';
import AddSociaty from './applySociety';
import WEBIM from '../../store/WebNim';
import './index.scss';

const JNTYPES = {
  1: '游戏',
  2: '娱乐',
  3: '主持',
};
class GodEnter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      JNTYPE: '1', //申请的技能类型
      shillName: '', //申请的技能名称
      modalState: '0', //1.选择技能类型 2.技能申请前提
      skillItems: [],
      applyProgress: {
        addFirstSkill: 0, //开通一个技能 1-已开通 0-未开通
        addSociaty: 0, //加入公会 1-已加入公会 0-未加入公会
        bindPhone: 0, //是否绑定手机号 1-已绑定 0-未绑定
        userCert: 0, //是否实名认证 1-已实名 0-未实名
        videoStudy: 0, //通过视频学习 1-已通过 0-未通过
        withdrawSet: 0, //绑定提现账户 1-已绑定 0-未绑定
      },
      xieyi: true,
      user: null,
      use_applyType: 0,
    };
    this.loading = false;
  }
  shouldComponentUpdate(newProps, newState) {
    const godEnter_visible = newProps.base?.godEnter_visible;
    const godEnter_visible_old = this.props.base?.godEnter_visible;
    if (godEnter_visible && !godEnter_visible_old) {
      this.showModal();
    }
    return true;
  }
  showModal = () => {
    if (this.loading) return;
    this.loading = true;
    this.getUserCenterInfo(() => {
      const { uid } = this.props.base;
      HTTP._get_findApplySimpleByUid({ uid }).then((res) => {
        this.loading = false;
        if (res.code == 200 && res.data) {
          this.setState({
            skillItems: res.data.skillItems || [],
            modalState: 1,
            use_applyType: res.data.applyType,
          });
        } else {
          message.warning(res.message);
        }
      });
    });
  };
  getUserCenterInfo = (callback) => {
    const { JNTYPE, skillName } = this.state;
    HTTP._get_user_center_info_v4({
      uid: this.props.base.uid,
    }).then((res) => {
      if (res.code == 200) {
        this.setState({
          user: res.data,
        });
      } else {
        message.error(res.message);
      }
    });
    //同步更新 申请条件
    if (this.state.modalState == 2) {
      this.setSQType(JNTYPE, skillName, (applyProgress) => {
        if (callback && typeof callback == 'function') callback(applyProgress);
      });
    } else {
      if (callback && typeof callback == 'function')
        callback(this.state.applyProgress);
    }
  };
  hideModal = () => {
    _show_god_end_visible(false);
    this.setState({ modalState: 0 });
  };
  //设置申请类型
  setSQType = (n, name, callback) => {
    if (this.loading) return;
    this.loading = true;
    const { uid } = this.props.base;
    HTTP._get_findGodApplyProgress({ uid, skillType: n }).then((res) => {
      this.loading = false;
      if (res.code == 200) {
        this.setState({
          JNTYPE: n,
          applyProgress: res.data,
          modalState: '2',
          skillName: name,
        });
        if (callback && typeof callback == 'function') callback(res.data);
      } else {
        message.warning(res.message);
      }
    });
  };
  //打开协议
  openRZLink = (e) => {
    e.stopPropagation();
    const url = '/godagreement/index.html';
    const {
      base: { rootConfig },
    } = this.props;
    const mobilePath = rootConfig?.protocolPath || rootConfig.mobilePath;
    let modalurl = mobilePath + url + '?v=' + rootConfig.version;
    this.iframeElement.showModal(modalurl);
  };
  //绑定手机
  bindPhone = () => {
    this.changePhoneElement.showModal(1);
  };
  //下载引导
  toApp = () => {
    WEBIM.events['OPEN_REAL_MODAL'] && WEBIM.events['OPEN_REAL_MODAL'](null);
  };
  //加入公会
  handleOpenJoinRule = () => {
    _h5_link_to('/join-guild-description').then((res) => {
      this.iframeElement.showModal(res.url + '?' + qs.stringify(res.params));
    });
  };
  //绑定银行卡
  bindBank = () => {
    this.bindBankElement.showModal();
  };
  //去申请
  toApplyClassLy = () => {
    if (this.state.xieyi == false) {
      message.warning('请详细阅读并同意《用户入驻条款》');
      return;
    }
    this.applyElement.showModal(this.state.JNTYPE, 'step1');
  };
  //取消申请公会
  cancelSociaty = () => {
    const { user } = this.state;
    Modal.info({
      title: '加入公会',
      icon: null,
      closable: true,
      content: (
        <div className="cancelSociaty-plan">
          <div className="cover">
            <img
              alt=""
              src={Util.transImgUrl(user.userSociatyVo.sociattyIcon)}
            />
          </div>
          <div className="detail">
            <div className="name">{user.userSociatyVo.sociatyName}</div>
            <p>公会正在审核中...</p>
          </div>
        </div>
      ),
      className: 'daidai-confirm-style daidai-btns-max',
      centered: true,
      okText: '取消申请',
      onOk: () => {
        return new Promise((resolve) => {
          HTTP._cancel_apply_join_sociaty({ uid: this.props.base.uid })
            .then((res) => {
              if (res.code === 200) {
                this.getUserCenterInfo();
                message.success('已取消公会申请');
                resolve();
              } else {
                message.warning((res && res.message) || '操作失败,请稍后重试');
              }
            })
            .finally(resolve);
        });
      },
    });
  };
  //取消技能申请
  cancelSkill = async () => {
    const { applyProgress } = this.state;
    let categoryId = applyProgress.applyCategoryId;
    if (!applyProgress.applyCategoryId) {
      message.warning('数据异常，请刷新后重试~');
      return;
    }
    const data = await HTTP._find_GodCategoryInfoByUid({
      uid: this.props.base.uid,
      categoryId,
    });
    if (data.code != 200 || !data.data) {
      message.warning(data.message);
      return;
    }
    Modal.info({
      title: '技能申请',
      icon: null,
      closable: true,
      content: (
        <div className="cancelSociaty-plan">
          <div className="cover">
            <img alt="" src={Util.transImgUrl(data.data.categoryIcon)} />
          </div>
          <div className="detail">
            <div className="name">
              {data.data.categoryName}
              <em>{data.data.level}</em>
            </div>
            <p>{data.data.price}</p>
          </div>
        </div>
      ),
      className: 'daidai-confirm-style daidai-btns-max',
      centered: true,
      okText: '取消申请',
      onOk: () => {
        return new Promise((resolve) => {
          HTTP._user_cancel_category({ categoryId })
            .then((res) => {
              if (res.code === 200) {
                this.getUserCenterInfo();
                message.success('已取消技能申请');
                resolve();
              } else {
                message.warning((res && res.message) || '操作失败,请稍后重试');
              }
            })
            .finally(resolve);
        });
      },
    });
  };
  render() {
    const { base } = this.props;
    const {
      user,
      skillItems,
      modalState,
      JNTYPE,
      applyProgress,
      xieyi,
      use_applyType,
      skillName,
    } = this.state;
    if (!user) return null;
    //公会
    const addSociatyContent = () => {
      if (applyProgress.addSociaty == 0) {
        return (
          <span
            className="btn btn-error"
            onClick={() => {
              this.addSociatyElement.showModal();
            }}
          >
            去加入
          </span>
        );
      }
      if (applyProgress.addSociaty == 1 || applyProgress.addSociaty == 4) {
        return <span className="btn">已加入</span>;
      }
      if (applyProgress.addSociaty == 2) {
        return (
          <span className="btn btn-warn hover" onClick={this.cancelSociaty}>
            审核中
            <HistoryOutlined />
          </span>
        );
      }
      if (applyProgress.addSociaty == 3) {
        return (
          <Popover
            content={
              <p style={{ width: '150px' }}>
                {applyProgress.refuseSociatyReason}
              </p>
            }
            title={null}
          >
            <span
              className="btn btn-error"
              onClick={() => {
                this.addSociatyElement.showModal();
              }}
            >
              未通过
              <QuestionCircleOutlined />
            </span>
          </Popover>
        );
      }
    };
    //技能
    const addSkillContent = () => {
      if (applyProgress.addFirstSkill == 0) {
        return (
          <span
            className="btn btn-error"
            onClick={() => {
              this.applyElement.showModal(JNTYPE, 'step1');
            }}
          >
            去开通
          </span>
        );
      }
      if (applyProgress.addFirstSkill == 1) {
        return <span className="btn">已开通</span>;
      }
      if (applyProgress.addFirstSkill == 3) {
        return (
          <span className="btn btn-warn">
            已提交
            <HistoryOutlined />
          </span>
        );
      }
      if (applyProgress.addFirstSkill == 2) {
        return (
          <span
            className="btn btn-warn hover"
            onClick={() => {
              this.cancelSkill();
            }}
          >
            审核中
            <HistoryOutlined />
          </span>
        );
      }
      if (applyProgress.addFirstSkill == 4) {
        return (
          <Popover
            content={
              <p style={{ width: '150px' }}>
                {applyProgress.refuseFirstSkillReason}
              </p>
            }
            title={null}
          >
            <span
              className="btn btn-error"
              onClick={() => {
                this.applyElement.showModal(JNTYPE, 'step1');
              }}
            >
              未通过
              <QuestionCircleOutlined />
            </span>
          </Popover>
        );
      }
    };
    //视频学习
    const addVideoContent = () => {
      if (applyProgress.videoStudy == 0) {
        return (
          <span
            className="btn btn-error"
            onClick={() => {
              this.applyElement.showModal(JNTYPE, 'step3');
            }}
          >
            去学习
          </span>
        );
      }
      if (applyProgress.videoStudy == 2) {
        return (
          <span
            className="btn btn-error"
            onClick={() => {
              this.applyElement.showModal(JNTYPE, 'step3');
            }}
          >
            未通过
          </span>
        );
      }
      if (applyProgress.videoStudy == 1) {
        return <span className="btn">已通过</span>;
      }
    };
    const showNextState =
      applyProgress.bindPhone != 1 ||
      applyProgress.userCert != 1 ||
      applyProgress.withdrawSet != 1 ||
      !applyProgress.addSociaty
        ? false
        : true;
    return (
      <Fragment>
        <Modal
          open={modalState == '1'}
          width="470px"
          title={'请选择您感兴趣的内容标签'}
          wrapClassName="daidai-modal-style has-top-border"
          centered={true}
          footer={null}
          keyboard={false}
          maskClosable={false}
          destroyOnHidden={true}
          onCancel={this.hideModal}
        >
          <div className="god-enter-modal-1">
            <h3>各技能要求不同，可点击申请查看要求</h3>
            {skillItems.map((item, index) => (
              <div className="jn-item" key={index}>
                <div
                  className="jn-icon icon-1"
                  style={{
                    backgroundImage: `url(${Util.transImgUrl(item.img)})`,
                  }}
                ></div>
                <div className="jn-center">
                  <div className="jn-name">{item.name}</div>
                  <div className="jn-desc">{item.desc}</div>
                </div>
                <div className="jn-actions">
                  {item.status ? (
                    <Button className="daidai-btn-primary" disabled>
                      已申请
                    </Button>
                  ) : (
                    <Button
                      className="daidai-btn-primary"
                      disabled={use_applyType && use_applyType != item.type}
                      onClick={this.setSQType.bind(this, item.type, item.name)}
                    >
                      {(use_applyType && use_applyType != item.type) ||
                      !use_applyType
                        ? '申请'
                        : null}
                      {use_applyType && use_applyType == item.type
                        ? '申请中'
                        : null}
                    </Button>
                  )}
                </div>
              </div>
            ))}
          </div>
        </Modal>
        <Modal
          open={modalState == '2'}
          width="570px"
          wrapClassName="daidai-modal-style has-top-border"
          centered={true}
          title={`${JNTYPES[JNTYPE]}技能`}
          footer={null}
          keyboard={false}
          maskClosable={false}
          onCancel={this.hideModal}
        >
          <div className="god-enter-modal-2">
            <div className="modal-title">{JNTYPES[JNTYPE]}大神权益</div>
            <div className="modal-box-1">
              <div className="box-item icon-1">
                <p className="p1">金币收益</p>
                <p className="p2">获得大神服务收益</p>
              </div>
              <div className="box-item icon-2">
                <p className="p1">专属曝光</p>
                <p className="p2">获得更多展示位</p>
              </div>
              <div className="box-item icon-3">
                <p className="p1">技能主页</p>
                <p className="p2">获得技能主页</p>
              </div>
              <div className="box-item icon-4">
                <p className="p1">扩列交友</p>
                <p className="p2">结识更多玩伴</p>
              </div>
            </div>
            <div className="modal-title">申请条件</div>
            <div className="modal-box-2">
              <div className="box-item icon-5">
                <div className="txt">绑定手机号</div>
                {applyProgress.bindPhone ? (
                  <span className="btn">已绑定</span>
                ) : (
                  <span className="btn btn-error" onClick={this.bindPhone}>
                    去绑定
                  </span>
                )}
              </div>
              <div className="box-item icon-6">
                <div className="txt">完成实名认证</div>
                {applyProgress.userCert ? (
                  <span className="btn">已认证</span>
                ) : (
                  <span
                    className="btn btn-error"
                    onClick={this.toApp.bind(
                      this,
                      '大神入驻需要先完成实名认证，请前往APP进行相关操作。'
                    )}
                  >
                    去认证
                  </span>
                )}
              </div>
              <div className="box-item icon-7">
                <div className="txt">合作服务商</div>
                {applyProgress.withdrawSet ? (
                  <Fragment>
                    {applyProgress.withdrawSet == 1 ? (
                      <span className="btn">已认证</span>
                    ) : (
                      <span
                        className="btn btn-error"
                        onClick={this.toApp.bind(
                          this,
                          '大神入驻需要先签约合作服务商平台认证，请前往APP进行相关操作。'
                        )}
                      >
                        待签约
                      </span>
                    )}
                  </Fragment>
                ) : (
                  <span className="btn btn-error" onClick={this.bindBank}>
                    待认证
                  </span>
                )}
              </div>
              <div className="box-item icon-8">
                <div className="txt">
                  加入公会{' '}
                  <QuestionCircleOutlined onClick={this.handleOpenJoinRule} />
                </div>
                {addSociatyContent()}
              </div>
              {(showNextState && applyProgress.addFirstSkill) ||
              applyProgress.cancelFirstSkill ? (
                <div className="box-item icon-9">
                  <div className="txt">成功开通一个技能</div>
                  {addSkillContent()}
                </div>
              ) : null}
              {(showNextState && applyProgress.addFirstSkill) ||
              applyProgress.cancelFirstSkill ? (
                <div className="box-item icon-10">
                  <div className="txt">通过视频学习</div>
                  {addVideoContent()}
                </div>
              ) : null}
            </div>
            {applyProgress.addFirstSkill == 0 &&
            !applyProgress.cancelFirstSkill ? (
              <div className="modal-box-3">
                <Button
                  disabled={showNextState == false}
                  className="daidai-btn-primary btn-submit"
                  onClick={this.toApplyClassLy}
                >
                  立即申请
                </Button>
                <div className="xy">
                  <label>
                    <Checkbox
                      checked={xieyi}
                      onChange={(e) => {
                        this.setState({ xieyi: e.target.checked });
                      }}
                    />
                    &nbsp;&nbsp;我已阅读并同意
                  </label>
                  <span onClick={this.openRZLink}>《用户入驻条款》</span>
                </div>
              </div>
            ) : null}
          </div>
        </Modal>
        {/* 初次资质申请 */}
        <ApplyRef
          wrappedComponentRef={(el) => (this.applyElement = el)}
          skillName={skillName}
          categoryId={applyProgress?.applyCategoryId}
          base={base}
          user={user}
          refresh={this.getUserCenterInfo}
        />
        {/* 绑定银行卡 */}
        <BindBank
          wrappedComponentRef={(el) => (this.bindBankElement = el)}
          base={base}
          user={user}
          refresh={this.getUserCenterInfo}
        />
        {/* 通用H5弹窗 */}
        <IframeModal wrappedComponentRef={(el) => (this.iframeElement = el)} />
        {/* 手机绑定 */}
        <ChangePhone
          wrappedComponentRef={(el) => (this.changePhoneElement = el)}
          user={user}
          refresh={this.getUserCenterInfo}
          base={base}
        />
        {/* 加入公会 */}
        <AddSociaty
          wrappedComponentRef={(el) => (this.addSociatyElement = el)}
          mode="modal"
          nextEvent={this.getUserCenterInfo}
          base={base}
        />
      </Fragment>
    );
  }
}

export default connect((store) => ({ base: store }))(
  withRouter(GodEnter, { withRef: true })
);
